import {
    Box,
    Flex, 
    Heading, 
    Button,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    AlertDialogCloseButton,
    Tooltip,
    useToast,
    Spinner
} from '@chakra-ui/react'
import React, { Fragment,useState } from 'react'
import { Link,useNavigate } from 'react-router-dom';
import BillDetails from '../../component/BillDetails'
import Details from '../../component/Details'
import RightSidebar from '../../component/RightSidebar'
import axios from 'axios'
import { Auth } from '../../component/Auth';


const OrderSummary = () => {
    const [render, setRender] = useState(0)
    const [render2, setRender2] = useState(0)
    const [deleteID, setDeleteId] = useState("")
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);
    const toast = useToast()
    const navigate = useNavigate()

    const onClose1 = () => setIsOpen1(false);
    const onClose2 = () => setIsOpen2(false);
    const onOpen1 = () => setIsOpen1(true);
    const onOpen2 = () => setIsOpen2(true);

    let orderSummaryData = JSON.parse(window.sessionStorage.getItem("order_summary"))
    // total amount no of item after adding each

    const totalOrderAmount = orderSummaryData?.orderItems?.reduce((accumulator, currentValue) => parseFloat(currentValue.finalPrice) + accumulator,0)
    // total refundable amount no of item after adding each
    const totalRefundableAmount = orderSummaryData?.orderItems?.reduce((accumulator, currentValue) => parseFloat(currentValue.refundableDeposit) + accumulator,0)
    // total amount of item price after adding each
    const totalAmountPrice = orderSummaryData?.orderItems?.reduce((accumulator, currentValue) => parseFloat(currentValue.totalPrice) + accumulator, 0)
    // total discount of item after adding each
    const totalDiscount = orderSummaryData?.orderItems?.reduce((accumulator, currentValue) => parseFloat(currentValue.discount) + accumulator, 0)
    
    // adding total amount and refundable amount to order object 
    const myObjTest = JSON.parse(window.sessionStorage.getItem('order_summary'))
    if(myObjTest !== null){
        myObjTest.grandTotal = totalOrderAmount !== null ? Number(totalOrderAmount) : ""
        myObjTest.totalRefundableAmount = totalRefundableAmount !== null ? Number(totalRefundableAmount) : ""
    }
    sessionStorage.setItem('order_summary', JSON.stringify(myObjTest))

    const deleteItemHandler = (data) => {
        onOpen1()
        setDeleteId(data)
      }

    const convertDate = (date) => {
        return new Intl.DateTimeFormat('it', { day: '2-digit', month: '2-digit', year: 'numeric', }).format(new Date(date))
    }
   
    const draftOrderHandler = () => {
        let shippingPayload = window.sessionStorage.getItem('shipping_Address_payload')
        let billingPayload = window.sessionStorage.getItem('billing_Address_payload')
        let finalOrderJSON = JSON.parse(window.sessionStorage.getItem("order_summary"))
        if(finalOrderJSON && !(finalOrderJSON.orderItems.length > 0)){
           navigate("/orders/all")
        }
        
        if(finalOrderJSON.customerPartyId === "" || finalOrderJSON.enteredByPartyId === ""){
            toast({
                title: 'Please select customer',
                position: 'top',
                status: 'warning',
                duration: 4000,
                isClosable: true,
              })
        }else if(!shippingPayload && !billingPayload){
            toast({
                title: 'Please add shipping and billing address',
                position: 'top',
                status: 'warning',
                duration: 4000,
                isClosable: true,
              })
        }else if(!shippingPayload) {
            toast({
                title: 'Please add shipping address',
                position: 'top',
                status: 'warning',
                duration: 4000,
                isClosable: true,
              })
        }else if(!billingPayload){
            toast({
                title: 'Please add billing address',
                position: 'top',
                status: 'warning',
                duration: 4000,
                isClosable: true,
              })
        }else{
             //  ######## Shipping Address call ######### //
             let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/address`,
                headers: { 
                  'Content-Type': 'application/json',
                  'Authorization': Auth()
                },
                data : shippingPayload
              };
              


              axios.request(config)
              .then((response) => {
                console.log(JSON.stringify(response.data));

              window.sessionStorage.setItem('shipping_Address_response', JSON.stringify(response.data))

            //  ##### Billing Address call ##### //
                          let config2 = {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/address`,
                            headers: { 
                              'Content-Type': 'application/json',
                              'Authorization': Auth()
                            },
                            data : billingPayload
                          };

                          axios.request(config2)
                          .then((response) => {
                            console.log(JSON.stringify(response.data));
                            
                            window.sessionStorage.setItem('billing_Address_response', JSON.stringify(response.data))
    
                            // ################## Main Draft Order API CALL ################ //
                            let billingId = JSON.parse(window.sessionStorage.getItem('billing_Address_response'))
                            let shippingId = JSON.parse(window.sessionStorage.getItem('shipping_Address_response'))
            
                            finalOrderJSON.shippingAddressId = `${shippingId.id}`
                            finalOrderJSON.billingAddressId = `${billingId.id}`
                            finalOrderJSON.custom_order = true
                            let data = JSON.stringify(finalOrderJSON);
                            
                            let config3 = {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/`,
                            headers: { 
                                'Content-Type': 'application/json',
                                'Authorization': Auth()
                            },
                            data : data
                            };
                    
                            axios.request(config3)
                            .then((response) => {
                            console.log(JSON.stringify(response.data));
                            toast({
                                title: "Order created successfully",
                                position: 'top',
                                status: 'success',
                                duration: 4000,
                                isClosable: true,
                              })
                            // isAutoVerified Functionality to sync shopify draft
                            if(finalOrderJSON.isAutoVerified === true){
                                let data4 = JSON.stringify({
                                    "orderId": `${response.data.id}`,
                                    "isAutoVerified": true,
                                    "orderGstNumber": response.data.orderGstNumber !== null ? response.data.orderGstNumber : 'n/a: Gst was not provided while creating order',
                                    "reqType": "POST"
                                });
                            
                                let config4 = {
                                    method: 'post',
                                    maxBodyLength: Infinity,
                                    url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/shopify/sync-draft-order`,
                                    headers: { 
                                    'Content-Type': 'application/json',
                                    'Authorization': Auth()
                                    },
                                    data : data4
                                };
                            
                                axios.request(config4)
                                .then((response) => {
                                
                                    console.log('Auto-verified')
                            
                                })
                                .catch((error) => {
                                    console.log(error);
                                    
                                    toast({
                                    title: `Something went wrong try again`,
                                    position: 'top',
                                    status: 'error',
                                    duration: 4000,
                                    isClosable: true,
                                    })
                            
                                });
                            }
                            window.sessionStorage.removeItem("order_summary")
                            window.sessionStorage.removeItem("billing_Address_response")
                            window.sessionStorage.removeItem("shipping_Address_response")
                            window.sessionStorage.removeItem("shipping_Address_payload")
                            window.sessionStorage.removeItem("billing_Address_payload")
                            window.sessionStorage.removeItem("customer_data")
                            navigate('/orders/all')
                            })
                            .catch((error) => {
                            console.log(error);
                            if(finalOrderJSON.customerPartyId === "" || finalOrderJSON.enteredByPartyId === ""){
                                toast({
                                    title: 'Customer not found',
                                    description: "Please add customer",
                                    position: 'top',
                                    status: 'warning',
                                    duration: 4000,
                                    isClosable: true,
                                  })
                            }else{  
                                toast({
                                    title: 'Error',
                                    description: "Something went wrong please try again",
                                    position: 'top',
                                    status: 'error',
                                    duration: 4000,
                                    isClosable: true,
                                  })
                            }
                            });
                    

                          })
                          .catch((error) => {
                            toast({
                                title: 'Oops we are facing some temporary issue with your request',
                                position: 'top',
                                status: 'error',
                                duration: 3000,
                                isClosable: true,
                              })
                            console.log(error);
                          });
              
              })
              .catch((error) => {
                toast({
                    title: 'Oops we are facing some temporary issue with your request',
                    position: 'top',
                    status: 'error',
                    duration: 3000,
                    isClosable: true,
                  })
                console.log(error);
              });

        }
    }
    // render summary when customer add to include party id in session storage using child to parent nested props
    const renderSummary = () => {
        setRender2((val) => render2 + 1)
    }
    // Format Date
    const formatDate = (date) => {
        const options = {
      year: "2-digit",
      month: "short",
      day: "numeric",
    };
    const dateString = date.toLocaleDateString("en-US", options);
    
    const timeString = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    
    
    return `${dateString}, ${timeString}`
    
    }

    // const startDateCal = (date) => {
    //     // Set the date to the first day of the next month
    //     const parts = date.split("-");
    //           const year = parts[0];
    //           const month = parts[1].padStart(2, "0");
    //           const day = parts[2].padStart(2, "0");
    //           const formattedDate = new Date(`${year}-${month}-${day}`);
    //     formattedDate.setMonth(formattedDate.getMonth() + 1);
    //     formattedDate.setDate(1);
        
    //     // Get the starting date of the next month
    //     return formattedDate.toISOString().slice(0, 10);
    //     }



    return (
        <Fragment>
        {orderSummaryData !== null ? 
         <Box width={'80%'}>
             <Flex justifyContent={'space-between'} p={4} pl={2} pb={0}>
                    <Flex flexBasis={"70%"} flexDirection={'row'} justifyContent={'space-between'}>
                        <Heading fontSize={"28px"} ml={4 }>Order Summary</Heading>
                        <Tooltip label={"Add Order Item"}>
                        <Link to={'/orders/create-order-item'}>
                            <Button
                                shadow={"md"}
                                colorScheme={'twitter'}
                                rounded={"full"}
                                mr={3}
                                
                            >
                                Add Item
                            </Button>
                        </Link>
                        </Tooltip>
                    </Flex>  
                    <Flex flexBasis={'30%'} justifyContent={'end'}>
                    <Box>
                    <Tooltip label={"Discard Order"}>
                        <Button
                        colorScheme={'red'}
                        mr={3}
                        size={"sm"}
                        px={6}
                        shadow={"md"}
                        rounded={"sm"}
                        onClick={onOpen2}
                        >
                        Discard
                        </Button>
                    </Tooltip>
                        <AlertDialog
                        isOpen={isOpen2}
                        onClose={onClose2}
                        motionPreset="slideInBottom"
                        isCentered
                        >
                        <AlertDialogOverlay>
                            <AlertDialogContent>
                            <AlertDialogHeader fontSize="lg" fontWeight="bold">
                                Discard Order
                            </AlertDialogHeader>

                            <AlertDialogBody>
                                Are you sure? You can't undo this action afterwards.
                            </AlertDialogBody>

                            <AlertDialogFooter>
                                <Button onClick={onClose2}>Cancel</Button>
                                <Button
                                colorScheme="red"
                                onClick={() => {
                                    onClose2()
                                    window.sessionStorage.removeItem("order_summary")
                                    window.sessionStorage.removeItem("customer_data")
                                    navigate('/orders/all')
                                    
                                }}
                                ml={3}
                                >
                                Discard
                                </Button>
                            </AlertDialogFooter>
                            </AlertDialogContent>
                        </AlertDialogOverlay>
                        </AlertDialog>
                        <Tooltip label={"Draft Order"}>
                        <Button
                        colorScheme="twitter"
                        size={"sm"}
                        px={6}
                        shadow={"md"}
                        rounded={"sm"}
                        onClick={draftOrderHandler}
                        >
                        Draft
                        </Button>
                        </Tooltip>
                         </Box>
                    </Flex>
                </Flex>
            <Flex justifyContent={'space-evenly'}>
            <Box p={5} pt={0} w={'70%'} bgColor='#F5F5F5'>
               {/* Details Page */}
                {orderSummaryData?.orderItems.map((d,i) => {
                    
                    return (
                        <Details   
                        key={i}
                        title={"Order Summary"}
                        orderDetails={{title: d.title, variant: d.variant, img: d.productImg, id: d.itemId, itemPrice: d.totalPrice, securityDeposit: d.refundableDeposit, subTotal: (((Number(d.totalPrice) - (Number(d.discount))))), discount: d.discount,totalPrice: d.finalPrice, quantity: d.quantity}}
                        deleteItemHandler={deleteItemHandler}
                        order={"Order Placed"}
                        tenureType={(d.tenure?.tenurePeriodType.charAt(0).toUpperCase() + d.tenure?.tenurePeriodType.slice(1).toLowerCase()) + (d.tenure?.tenurePeriodType === "WEEKLY" ? "" : " Tenure") || null}
                        tenureTypeTotal={(d.tenure?.tenurePeriodType === "WEEKLY") ? ('₹' + Number(d.tenure?.pricePerWeek).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) + "/Week") 
                          : ('₹' + Number(d.tenure?.pricePerMonth).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2, }) + "/Month") }
                        // total rent without added discount ?
                        rent={'₹' + Number((d.tenure?.tenurePeriodType === "MONTHLY" ? d.tenure?.pricePerMonth : d.tenure?.pricePerWeek) * d.tenure?.tenurePeriod).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })} 
                        btnColorScheme={'twitter'}
                        btnText={orderSummaryData.orderStatusId}
                        orderDate={formatDate(new Date(orderSummaryData.pacedDate))}
                        productName={'Product Name'}
                        productBtnText={"Assign for Delivery"} 
                        productBtnItems={["Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Aditya Sharma","Deepak Sharma","Gagan Verma"]}
                        row1={[{"Order Date": formatDate(new Date(orderSummaryData.pacedDate))},
                        {[d.tenure?.tenurePeriodType === "WEEKLY" ? "Start Date" : "Tenure Start Date"]:new Date(orderSummaryData.delivery_date).toLocaleDateString('en-IN')},
                        {[d.tenure?.tenurePeriodType === "WEEKLY" ? "End Date" : "Tenure End Date"]: convertDate(d.tenure?.endDate)},
                        {[d.tenure?.tenurePeriodType === "WEEKLY" ? "Period" : "Tenure Period"]: `${d.tenure?.tenurePeriod} ${d.tenure?.tenurePeriodType === "MONTHLY" ? d.tenure?.tenurePeriod === "1" ? "Month" : "Months" : d.tenure?.tenurePeriod === "1" ? "Week" : "Weeks"}`}]}
                        />
                    )
                })}
                
                <BillDetails
                    bills={[{"Base Price":["", '₹'+ Number(totalAmountPrice).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })]},
                        {"Tenure Discount":["", '₹' + Number(totalDiscount).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })]},
                        {"Subtotal":["", '₹' + Number(totalAmountPrice - totalDiscount).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })]},
                        {"Total Tax":["18% GST", '₹' + Number((Number(totalAmountPrice - totalDiscount) * 0.18)).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })]},
                        {"Total Security Deposite":["", '₹' + Number(totalRefundableAmount).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })]},
                          
                    ]}
                    total={Number(totalOrderAmount).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                    paid={null}
                 />
            </Box>
            <Box pr={3} py={3} w={'30%'} bgColor='#F5F5F5'>
                <RightSidebar
                    title={'Order Summary'}
                    customerName={'John Doe'}
                    customerGmail={'John@xyz.com'}
                    customerPhone={'9111112225'}
                    shippingArea={'Unkown Area'}
                    shippingCity={'Unkown City'}
                    billingAddress={"Same as shipping address"}
                    renderSummary={renderSummary} />
            </Box>
            </Flex>




            <AlertDialog
                isOpen={isOpen1}
                onClose={onClose1}
                motionPreset="slideInBottom"
                isCentered
            >
                <AlertDialogOverlay />
                <AlertDialogContent>
                    <AlertDialogHeader>Delete</AlertDialogHeader>
                    <AlertDialogCloseButton />
                    <AlertDialogBody>
                        Are you sure you want to delete this order item.
                    </AlertDialogBody>
                    <AlertDialogFooter>
                        <Button  onClick={onClose1}>
                        No
                        </Button>
                        <Button colorScheme='red' ml={3} onClick={() => {
                            orderSummaryData.orderItems = orderSummaryData.orderItems.filter((d) => d.itemId !== deleteID)
                            sessionStorage.setItem('order_summary', JSON.stringify(orderSummaryData))
                            setRender(value => render + 1)
                            onClose1()
                            orderSummaryData && !(orderSummaryData.orderItems.length > 0) && navigate("/orders/all")
                        }}>
                        Yes
                        </Button>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialog>
            </Box>
            :
            <Flex w={'100%'} justifyContent={'center'} mt={8}>
                    <Spinner
                    thickness='4px'
                    speed='0.65s'
                    emptyColor='gray.200'
                    color='blue.500'
                    size='xl'
                    />
            </Flex>
            
        }
        </Fragment>
    )
}

export default OrderSummary
